<div id="admin-tools-view">
  <sg2-admin-tools-find-circular></sg2-admin-tools-find-circular>
</div>
